import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const query = gql`
query getAllowedDomains {
  allowedDomains {
    id
    domain
  }
}`;

function getAllowedDomains() {
  return apollo.client.query({
    query,
    fetchPolicy: 'network-only',
  }).then((res) => res.data.allowedDomains);
}

export default getAllowedDomains;
